export default __webpack_public_path__ + "static/media/SelfBookInfoIcon.8e77d718.svg";